import 'utils/responsiveScreenAdapter.js';
import 'utils/mtaStatistic.js';
import Vue from 'vue';
import App from '@/App.vue';

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount('#app');
